import React from 'react';
import Svg from '@jg/svg';
import { Button } from '@jg/react-tracking';
import * as icons from '@jg/icons';
import { TTrackData } from '../../types/state.d';

export type StepNavigationProps = {
  currentStep: number;
  totalSteps?: number;
  onBackButtonClick?: () => void;
  trackingData?: TTrackData;
};

const StepNavigation = ({
  currentStep,
  totalSteps = 4,
  onBackButtonClick,
  trackingData,
}: StepNavigationProps) => (
  <div className="row jg-space-ptms jg-space-mbmd">
    <div className="col-xs-3">
      {onBackButtonClick && (
        <Button
          onClick={onBackButtonClick}
          className="jg-btn--invisible"
          data-qa="back-button"
          type="button"
          trackingData={trackingData}
        >
          <span className="jg-sr-only">Back</span>
          <Svg
            markup={icons.chevronLeftIcon}
            className="jg-icon jg-icon--medium jg-fill--dark-orchid jg-display-ib jg-cursor-pointer"
          />
        </Button>
      )}
    </div>
    <span
      className="col-xs-6 jg-text--center jg-text--brand-small"
      data-qa="step"
    >
      {currentStep}/{totalSteps}
    </span>
  </div>
);

export default StepNavigation;
